// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigation-group[data-v-3ec445d5]{float:left}.actions-group[data-v-3ec445d5]{float:right}\n", ""]);
// Exports
module.exports = exports;
